import { BaseButton } from "@/shared/ui/BaseButton";
import { BaseIcon } from "@/shared/ui/BaseIcons";
import { BaseKeyValue } from "@/shared/ui/BaseKeyValue";
import { Delete as DeleteIcon, Edit as EditIcon } from "@mui/icons-material";
import { Box, Card, CardContent, Stack, Typography } from "@mui/material";
import type { FreightMatching } from "@x-mile/api-contract";

type Props = {
  scheduledCarrier:
    | FreightMatching.schemas.OfferCargo["scheduledCarrier"]
    | null
    | undefined;
  onEdit: () => void;
  onDelete: () => void;
  onAdd: () => void;
};

export const ScheduledCarrierSection = ({
  scheduledCarrier,
  onEdit,
  onDelete,
  onAdd,
}: Props) => {
  if (!scheduledCarrier) {
    // 未登録の場合
    return (
      <Box>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Typography variant="h6" fontWeight={700}>
            配送予定車両
          </Typography>
        </Stack>
        <Card variant="outlined">
          <CardContent>
            <Stack justifyContent="center" alignItems="center" p={4}>
              <BaseButton
                variant="outlined"
                startIcon={<BaseIcon name="plus" />}
                onClick={onAdd}
              >
                配送予定車両を登録してください
              </BaseButton>
            </Stack>
          </CardContent>
        </Card>
      </Box>
    );
  }

  // 登録済みの場合
  return (
    <Box>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h6" fontWeight={700}>
          配送予定車両
        </Typography>
        <Stack direction="row" spacing={1}>
          <BaseButton
            variant="outlined"
            startIcon={<EditIcon />}
            onClick={onEdit}
          >
            編集
          </BaseButton>
          <BaseButton
            variant="outlined"
            color="error"
            startIcon={<DeleteIcon />}
            onClick={onDelete}
          >
            削除
          </BaseButton>
        </Stack>
      </Stack>
      <BaseKeyValue keyLabel="実運送会社">
        <Typography variant="body2" color="grey.900">
          {scheduledCarrier.name || "(未入力)"}
        </Typography>
      </BaseKeyValue>
      <BaseKeyValue keyLabel="車両番号">
        <Typography variant="body2" color="grey.900">
          {scheduledCarrier.vehicleNumber || "(未入力)"}
        </Typography>
      </BaseKeyValue>
      <BaseKeyValue keyLabel="運転手名">
        <Typography variant="body2" color="grey.900">
          {scheduledCarrier.contactName || scheduledCarrier.contactNameKana
            ? `${scheduledCarrier.contactName}${
                scheduledCarrier.contactNameKana
                  ? ` (${scheduledCarrier.contactNameKana})`
                  : ""
              }`
            : "(未入力)"}
        </Typography>
      </BaseKeyValue>
      <BaseKeyValue keyLabel="電話番号">
        <Typography variant="body2" color="grey.900">
          {scheduledCarrier.phoneNumber || "(未入力)"}
        </Typography>
      </BaseKeyValue>
    </Box>
  );
};
